import React from 'react';
import {Flex, Button, Form, Edit, Textarea, Submit} from 'components';
import {api, useNamedSelector} from 'helpers';
import {store} from 'store';

export function Support({ popup }) {
  const { email } = useNamedSelector('session.user');
  return (
    <Form onSubmit={submit} initialValues={{ name: '', comment: '', email, popup }}>
      <div>
        <h2>We are here to help. </h2>
        <p className="small-spacing">Please tell us what is your comment or question. We will reply within 24 hours.</p>
        <p><Edit name="name" placeholder="Enter your name.." /></p>
        <p><Textarea name="comment" placeholder="Enter your comment.." required minRows="10" /></p>
      </div>
      <Flex className={['right', 'spacing', 'tiny-gutter']}>
        <Button className="borderless" onClick={popup.close}>Cancel</Button>
        <Submit>{[ 'Submit', 'Submitting..' ]}</Submit>
      </Flex>
    </Form>
  );
}

async function submit(values) {
  const { popup, ...fields } = values;
  try {
    await api('/contact-us/', {
      type: 'support-request',
      ...fields,
    });
    store.dispatch({
      type: 'UI_NOTIFICATION',
      notification: 'Your request has been submitted!',
    });
    popup.close();
  } catch (error) {
    store.dispatch({
      type: 'UI_ERROR',
      errorMessage: 'Server is not responding. Please try again later.',
      error,
    });
    throw error;
  }
}
